<template>
    <section class="slice barometer-home__prices__summary">
        <h2 class="slice-title joy-mb-8">{{ generalBarometer.priceTitle?.replace(' ?', '&nbsp;?') }}</h2>
        <div v-html="t('barometer.general.summary', [generalBarometer.nbFreelancers])" />
    </section>
</template>

<script setup lang="ts">
    import {inject} from 'vue';
    import {useTranslation} from '#imports';
    import {BAROMETER_HOME} from '~/keys';

    const {t} = useTranslation();
    const {generalBarometer} = inject(BAROMETER_HOME)!;
</script>

<style lang="scss">
    .barometer-home__prices__summary {
        text-align: left;

        p:not(:last-child) {
            margin-bottom: var(--joy-core-spacing-4);
        }

        ul {
            margin-left: var(--joy-core-spacing-8);
            margin-bottom: var(--joy-core-spacing-8);
        }
    }
</style>
